import {
  GET_CATEGORY,
  GET_CATEGORY_BY_ID,
  GET_CATEGORY_BY_ID_SUCCESS,
  GET_CATEGORY_SUCCESS,
  GET_CATEGORY_ERROR,
  GET_CATEGORY_LIST,
  GET_CATEGORY_LIST_SUCCESS,
  GET_CATEGORY_LIST_ERROR,
} from "./actionTypes"

export const getProductCategory = data => ({
  type: GET_CATEGORY,
  payload: data,
})
export const getProductCategoryById = id => ({
  type: GET_CATEGORY_BY_ID,
  id: id,
})

export const getProductCategorySuccess = data => ({
  type: GET_CATEGORY_SUCCESS,
  payload: data,
})

export const getProductCategoryByIdSuccess = data => ({
  type: GET_CATEGORY_BY_ID_SUCCESS,
  payload: data,
})

export const getProductCategoryError = data => ({
  type: GET_CATEGORY_ERROR,
  payload: data,
})

export const getProductCategoryList = data => ({
  type: GET_CATEGORY_LIST,
  payload: data,
})

export const getProductCategoryListSuccess = data => ({
  type: GET_CATEGORY_LIST_SUCCESS,
  payload: data,
})

export const getProductCategoryListError = data => ({
  type: GET_CATEGORY_LIST_ERROR,
  payload: data,
})
